import { useSearchParams } from 'react-router-dom';

/**
 * Custom hook to determine if the app bar (header/footer) should be shown
 * Based on the URL parameter ?showAppBar=false
 * 
 * @returns {boolean} - true if app bar should be shown, false otherwise
 */
export const useAppBarVisibility = (): boolean => {
    const [searchParams] = useSearchParams();

    // Get the showAppBar parameter
    const showAppBarParam = searchParams.get('showAppBar');

    // Default to true (show app bar) unless explicitly set to 'false'
    // This handles cases like ?showAppBar=0, ?showAppBar=no, etc.
    return showAppBarParam !== 'false';
};